import { Icon } from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const StyledIcon = styled(Icon)<{
  $isDisabled: boolean;
  $isRead: boolean;
  $enableHover: boolean;
  $isBordered: boolean;
}>`
  ${({ $enableHover }) =>
    $enableHover &&
    css`
      &:hover {
        transform: scale(1.25);
        cursor: pointer !important;
      }
    `}

  ${({ $isDisabled, $isRead, $isBordered }) =>
    ($isDisabled || $isRead) &&
    !$isBordered &&
    css`
      > path {
        fill: var(--icon-soft);
      }
    `}

  ${({ $isDisabled, $isRead, $isBordered }) =>
    ($isDisabled || $isRead) &&
    $isBordered &&
    css`
      > path:first-child {
        fill: var(--surface-default);
        stroke: var(--icon-soft);
      }
      > path:last-child {
        fill: var(--icon-soft);
      }
    `}
`;
